// React
import { useState } from "react"

// Types
import type { PaginationType } from "../../types"

export function usePagination(): {
  currentPage: number
  limit: number
  getRowNumber: (index: number) => number
  onChangePage: (page: number) => void
  onChangeLimit: (size: number) => void
  onChangePaginationData: (value: PaginationType) => void
  resetPage: () => void
  size: number
  total: number
  totalPage: number
} {
  // Hooks
  const [limit, setLimit] = useState<number>(10)
  const [page, setPage] = useState<number>(1)
  const [pages, setPages] = useState<number>(0)
  const [size, setSize] = useState<number>(0)
  const [total, setTotal] = useState<number>(0)

  // Functions
  const getRowNumber = (index: number): number => (index + 1) + (limit * (page - 1))
  const onChangePage = (page: number): void => setPage(page)
  const onChangeLimit = (size: number): void => setLimit(size)
  const resetPage = (): void => setPage(1)
  const onChangePaginationData = (value: PaginationType): void => {
    setPages(value.pages)
    setTotal(value.total)
    setSize(value.size)
  }

  return {
    limit,
    size,
    total,
    getRowNumber,
    onChangePage,
    onChangePaginationData,
    onChangeLimit,
    resetPage,
    currentPage: page,
    totalPage: pages
  }
}